import axios from "axios";
import {
  LOGIN_FAILED,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_AUTH,
  LOGIN_SUCCESS_PHONE,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILED,
  TEMP_SIGN_UP_SUCCESS,
  TEMP_SIGN_UP_FAILED,
  SIGN_UP_START,
} from "./actionTypes";

import Swal from "sweetalert2";

const customId = "custom-id-yes";
const customId1 = "custom-id-yess";

const loginStart = () => {
  return {
    type: LOGIN_START,
  };
};
const signupStart = () => {
  return {
    type: SIGN_UP_START,
  };
};
const tempsignin = () => {
  return {
    type: TEMP_SIGN_UP_SUCCESS,
  };
};
const tempsignfailed = () => {
  return {
    type: TEMP_SIGN_UP_FAILED,
  };
};

const loginSuccess = (username, userDetails) => {
  return {
    type: LOGIN_SUCCESS,
    username: username,
    userDetails: userDetails,
  };
};

const loginFailed = (message) => {
  return {
    type: LOGIN_FAILED,
    message: message,
  };
};
const signSuccess = (username, password, name, email, phonenumber) => {
  return {
    type: SIGN_UP_SUCCESS,
    username: username,
    password: password,
    name: name,
    email: email,
    phonenumber: phonenumber,
  };
};
export const signFailed = (message) => {
  return {
    type: SIGN_UP_FAILED,
    message: message,
  };
};

export const setAuth = (value) => {
  return {
    type: SET_AUTH,
    value: value,
  };
};

// export const logouttstart = (value) => {
//   return {
//     type: LOGOUT_START,
//   };
// };
// export const logouttsuccess = (value) => {
//   return {
//     type: LOGOUT_SUCCESS,
//   };
// };
export const logoutt = (value) => {
  return {
    type: LOGOUT,
  };
};

export const login = (username, password) => async (dispatch) => {
  dispatch(loginStart());

  const generator = Math.floor(Math.random() * 100000000);

  try {
    const xCheckSumValues = username;
    if (typeof username == "string") {
      var res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/api/auth/v1/login`,
        {
          username: username,
          password: password,
          // is2factorAuth: 0,
          // requestId: xCheckSumValues.generator,
          // isDebug: false,
        },
        {
          headers: {
            "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
          },
        }
      );
    }

    if (typeof username == "number") {
      var res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/api/auth/v1/login`,
        {
          phone: username,
          password: password,
          // is2factorAuth: 0,
          // requestId: xCheckSumValues.generator,
        },
        {
          headers: {
            "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
          },
        }
      );
    }

    // const status = await res.data.statusDescription.statusCode;

    // alert(res.data.statusDescription.description, status);

    if (res.data.statusDescriptions.statusCode == 200) {
      // await setTimeout(() => {
      //   toast.success("Logged In Successfully", {
      //     theme: "colored",
      //   });
      // }, 100);
      await setTimeout(() => {
        document.getElementById("li_sidebar_main0")?.click();
      }, 1000);

      localStorage.setItem("UserId", res.data.userModel.id);
      localStorage.setItem("usermodal", JSON.stringify(res.data.userModel));
      localStorage.setItem("usernamedisplayed", res.data.userModel.username);
      localStorage.setItem("password", password);

      // localStorage.setItem("items", JSON.stringify(res.data.userDetail));

      localStorage.setItem(
        "token",
        res.data.userModel.userTokenList[0].jwtToken
      );

      localStorage.setItem("Sidebaritems", JSON.stringify(res.data.role));

      // dispatch(loginSuccess());
      dispatch(loginSuccess(username));
      // dispatch(setAuth(res.data.token));
    } else if (
      res.data.statusDescriptions.statusCode == 223 &&
      res.data.statusDescriptions.statusDescription ==
        "Dear User, Your account is under verification..." &&
      res.data.userDetail.userTokenDetails.jwtToken
    ) {
      dispatch(tempsignin());
      // await setTimeout(async () => {
      //   await toast.success(" Please Verify Your Status", {
      //     theme: "colored",
      //   });
      // }, 100);
      localStorage.setItem("details", JSON.stringify(res?.data?.userDetail));

      localStorage.setItem(
        "statuscode",
        res?.data?.statusDescription?.statusCode
      );
      // localStorage.setItem("status", JSON.stringify(res.data.userDetail));

      localStorage.setItem("otpstatus", res?.data?.userDetail?.otpVerification);
      localStorage.setItem(
        "emailverification",
        res?.data?.userDetail?.emailVerification
      );
      localStorage.setItem("userId", res?.data?.userDetail?.uid);
      localStorage.setItem(
        "tokemtemp",
        res?.data?.userDetail?.userTokenDetails?.jwtToken
      );
    } else {
      // await toast.error(res.data.statusDescriptions.statusDescription, {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: res.data.statusDescriptions.statusDescription,
        // footer: '<a href="">Why do I have this issue?</a>'
      });
      dispatch(loginFailed());
    }
  } catch (error) {
    console.log(error);
    // await toast.error("Something Went Wrong !! Please check your network", {
    //   theme: "colored",
    // });
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something Went Wrong !! Please check your network ",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
    dispatch(loginFailed());
  }
};

export const logout = (reason) => async (dispatch) => {
  try {
    // alert("kello")

    if (localStorage.getItem("usernamedisplayed")) {
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/api/auth/v1/logout`,
        {
          username: localStorage.getItem("usernamedisplayed"),
        },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            userId: localStorage.getItem("UserId"),
            // source: "web",
            // Accept: "application/json",
          },
        }
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        // alert("if aprt")
        localStorage.clear();
        dispatch(logoutt());
        // await (window.location.href = "/");
        // setTimeout(() => {
        //   toast.success("Logged Out", {
        //     theme: "colored",
        //     toastId: customId1,
        //   });
        // }, 200);
      } else {
        // alert("esle aprt")
        localStorage.clear();
        dispatch(logoutt());
        // await (window.location.href = "/");
        // setTimeout(() => {
        //   toast.success("Logged Out", {
        //     theme: "colored",
        //     toastId: customId1,
        //   });
        // }, 200);
      }
    }
  } catch (error) {
    // alert("cartch aprt")
    // console.log(error, "catch errir");
    localStorage.clear();
    dispatch(logoutt());
    // await toast.error("Session expired", {
    //   theme: "colored",
    //   toastId: customId1,
    // });
  }
};
